import Button from "@mui/material/Button";

const MyButton = ({ isPressed, children, ...others }) => {
  return (
    <Button
      name="button"
      {...others}
      sx={{
        backgroundColor: isPressed ? "rgba(0, 0, 0, 0.08)" : "transparent",
        borderRadius: 0,
      }}
    >
      {children}
    </Button>
  );
};

export default MyButton;
